import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { FocusStyleManager } from "@blueprintjs/core";
import * as Sentry from "@sentry/react";

import {
  AppCrashFallback,
  GlobalHelmet,
  GlobalStyles,
  LoadingScreen,
  Tracking,
} from "@components";
import { AppProvider } from "@providers/AppProvider";
import { AppRoutes } from "@routes/AppRoutes";

FocusStyleManager.onlyShowFocusOnTabs();

/**
 * We add the react-router outside the App element, so that calling
 * history.go(0) re-renders the whole <App />.
 */
const App = () => (
  <Router>
    <GlobalStyles />
    <GlobalHelmet />
    <AppProvider>
      <Route path="/">
        <Tracking />
      </Route>
      <React.Suspense fallback={<LoadingScreen />}>
        <AppRoutes />
      </React.Suspense>
    </AppProvider>
  </Router>
);

export default Sentry.withErrorBoundary(App, {
  showDialog: true,
  fallback: ({ resetError }) => <AppCrashFallback resetError={resetError} />,
});
